/* TrueSanity wishlist page (sections/ts-wishlist.liquid). Needs assets/ts-wishlist.js (window.TSW).
   Each saved piece is checked live: Shopify price for products and settings, the diamond feed for
   diamonds (still for sale? price now?). "Complete & add to bag" reopens the builder's last step with
   the saved setting and diamond; the builder reloads the diamond and adds to bag the usual way. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tsw-page]');
  if (!root) return;
  var DAPI = 'https://truesanity.011101100110111001110011.net/api/', DKEY = 'TSANITY121A3VG7NEMVRXXEWGM';
  var NAT_API = window.TS_NATURAL_API || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/vdb-diamonds';   // natural: VDB feed in Supabase
  var SHARE = new URLSearchParams(location.search).get('share');
  var T, esc, money;
  var KIND = {
    product: 'Jewelry', setting: { ring: 'Engagement ring setting', pendant: 'Pendant setting', earring: 'Earring setting' },
    dyo: { ring: 'Design your own ring', pendant: 'Design your own necklace', earring: 'Design your own earrings' },
    diamond: { lab: 'Lab grown diamond', natural: 'Natural diamond', pair: 'Lab grown diamond pair' }
  };
  function kindLabel(it) {
    var k = KIND[it.kind];
    if (typeof k === 'string') return k;
    return (k && k[it.kind === 'diamond' ? (it.dtype || 'lab') : (it.build || 'ring')]) || '';
  }
  function $(s, el) { return (el || document).querySelector(s); }

  /* ---------- live checks ---------- */
  var pcache = {};
  function product(handle) {
    if (!handle) return Promise.resolve(null);
    if (!pcache[handle]) pcache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return pcache[handle];
  }
  function dapi(path) {
    // 404 / 410 = sold; any other failure = can't tell right now (the card keeps its saved price)
    // natural/<id> and lab/<id>: VDB in Supabase (old lab ids are passed through to the old service there)
    var url = /^natural\//.test(path) ? NAT_API + '/' + path.slice(8) : /^lab\//.test(path) ? NAT_API + '/' + path.slice(4) + '?kind=lab' : DAPI + path;
    return fetch(url, { headers: { 'Accept': 'application/json', 'X-API-Key': DKEY } })
      .then(function (r) { if (r.status === 404 || r.status === 410) return null; if (!r.ok) throw new Error('feed ' + r.status); return r.json(); });
  }
  function cents(x) { var n = parseFloat(x); return isNaN(n) ? 0 : Math.round(n * 100); }
  // resolves to the price in cents, null when sold; rejects when the feed can't be reached (shown as unknown)
  function diamondNow(d) {
    if (!d || !d.id) return Promise.resolve(null);
    var id = String(d.id);
    if (/^m\d+-\d+$/.test(id)) {
      return Promise.all(id.slice(1).split('-').map(function (one) { return dapi('diamonds/apiservices/new_api/' + one); })).then(function (ab) {
        if (!ab[0] || !ab[1] || !(ab[0].Diamond_ID || ab[0].diamond_id) || !(ab[1].Diamond_ID || ab[1].diamond_id)) return null;
        return cents(ab[0].total_sales_price || ab[0].Total_Price) + cents(ab[1].total_sales_price || ab[1].Total_Price);
      });
    }
    var type = d.pair || d.type === 'pair' || d.dtype === 'pair' ? 'pair' : (d.type === 'natural' || d.dtype === 'natural') ? 'natural' : 'lab';
    var path = type === 'natural' ? 'natural/' : type === 'pair' ? 'diamonds/apiservices/dyoe/new_api/' : 'lab/';
    return dapi(path + encodeURIComponent(id)).then(function (x) {
      if (!x || !(x.Diamond_ID || x.diamond_id || x.Diamond_ID2 || x.diamond_id2)) return null;
      if (type === 'pair') return cents(x.total_sales_price1 || x.Total_Price1) + cents(x.total_sales_price2 || x.Total_Price2);
      return cents(x.total_sales_price || x.Total_Price);
    });
  }
  function variantOf(p, vid) { return p && ((p.variants || []).filter(function (v) { return String(v.id) === String(vid); })[0] || p.variants[0]); }
  function check(it) {
    if (it.kind === 'product' || it.kind === 'setting') {
      return product(it.handle).then(function (p) {
        if (!p) return { gone: true };
        var v = variantOf(p, it.vid) || {};
        var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
        return { price: v.price, title: it.title || p.title, image: it.image || (img ? String(img).replace(/^\/\//, 'https://') : ''), sub: it.sub || (v.title && v.title !== 'Default Title' ? v.title : '') };
      });
    }
    if (it.kind === 'diamond') {
      return diamondNow(it.diamond || { id: it.id, dtype: it.dtype }).then(function (c) { return c == null ? { sold: true } : { price: c }; });
    }
    if (it.kind === 'dyo') {
      var s = it.setting || {};
      return Promise.all([product(s.handle), diamondNow(it.diamond)]).then(function (r) {
        if (r[1] == null) return { sold: true };
        var v = variantOf(r[0], s.vid);
        return { price: (v ? v.price : (s.price || 0)) + r[1] };
      });
    }
    return Promise.resolve({});
  }

  /* ---------- actions ---------- */
  function builderState(it) { var k = 'ts2_' + (it.build || 'ring'); try { return [k, JSON.parse(localStorage.getItem(k) || '{}') || {}]; } catch (e) { return [k, {}]; } }
  function complete(it) {
    var b = builderState(it), state = b[1];
    state.setting = it.setting; state.diamond = it.diamond;
    try { localStorage.setItem(b[0], JSON.stringify(state)); } catch (e) {}
    location.href = (it.builder || '/pages/build-your-ring') + '?step=complete&fresh=1';
  }
  function similar(it) {
    var d = it.diamond || {}, shape = d.shape || it.shape || '', ct = (d.stones && d.stones[0] && d.stones[0].carat) || d.carat || it.carat || '';
    if (it.kind === 'dyo') {
      var b = builderState(it), state = b[1]; state.setting = it.setting; delete state.diamond;
      try { localStorage.setItem(b[0], JSON.stringify(state)); } catch (e) {}
    }
    var q = new URLSearchParams({ step: 'diamond' }); if (shape) q.set('shape', String(shape).charAt(0).toUpperCase() + String(shape).slice(1).toLowerCase()); if (ct) q.set('ct', ct);
    location.href = (it.builder || '/pages/build-your-ring') + '?' + q.toString();
  }

  /* ---------- render ---------- */
  var items = [];
  function card(it, i) {
    var acts = '';
    if (it.kind === 'dyo') acts = '<button type="button" class="tswp__btn" data-act="complete">Complete &amp; add to bag</button>';
    else if (it.kind === 'setting') acts = '<a class="tswp__btn" href="' + esc(it.url || '#') + '">Choose your ' + (it.build === 'earring' ? 'diamonds' : 'diamond') + '</a>';
    else if (it.kind === 'diamond') acts = '<a class="tswp__btn" href="' + esc(it.url || '#') + '">View diamond</a>';
    else acts = '<a class="tswp__btn" href="' + esc(it.url || '#') + '">Shop now</a>';
    var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title || '') + '" loading="' + (i < 8 ? 'eager' : 'lazy') + '" decoding="async" width="500" height="500"' + (/_diamond_shape\.png/.test(it.image) ? ' class="is-icon"' : '') + '>' : '';
    return '<article class="tswp-card" data-key="' + esc(it.key) + '">' +
      '<a class="tswp-card__img" href="' + esc(it.kind === 'dyo' ? '#' : (it.url || '#')) + '"' + (it.kind === 'dyo' ? ' data-act="complete"' : '') + ' tabindex="-1" aria-hidden="true">' + img + '</a>' +
      (SHARE ? '' : '<button type="button" class="tswp-card__x" data-act="remove" aria-label="Remove ' + esc(it.title || 'this piece') + ' from your wishlist"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button>') +
      '<p class="tswp-card__kind">' + esc(kindLabel(it)) + '</p>' +
      '<a class="tswp-card__title" href="' + esc(it.kind === 'dyo' ? '#' : (it.url || '#')) + '"' + (it.kind === 'dyo' ? ' data-act="complete"' : '') + '>' + esc(it.title || '') + '</a>' +
      (it.sub ? '<p class="tswp-card__sub">' + esc(it.sub) + '</p>' : '') +
      '<p class="tswp-card__price" data-price>' + (it.price ? money(it.price) : '') + '</p>' +
      '<p class="tswp-card__change" data-change hidden></p>' +
      (it.make ? '<p class="tswp-card__make">We make ' + esc(it.make) + '%</p>' : '') +
      '<div class="tswp-card__acts" data-acts>' + acts + '</div>' +
    '</article>';
  }
  function paintLive(el, it, r) {
    if (!el || !r) return;
    if (r.title && !it.title) $('.tswp-card__title', el).textContent = r.title;
    if (r.image && !$('.tswp-card__img img', el)) $('.tswp-card__img', el).innerHTML = '<img src="' + esc(r.image) + '" alt="" loading="lazy" width="500" height="500">';
    if (r.sub && !it.sub) $('.tswp-card__title', el).insertAdjacentHTML('afterend', '<p class="tswp-card__sub">' + esc(r.sub) + '</p>');
    var ch = $('[data-change]', el);
    if (r.gone) { el.classList.add('is-sold'); $('[data-price]', el).textContent = 'No longer available'; $('[data-acts]', el).innerHTML = ''; return; }
    if (r.sold) {
      el.classList.add('is-sold');
      $('.tswp-card__img', el).insertAdjacentHTML('beforeend', '<span class="tswp-card__sold">Sold</span>');
      ch.hidden = false; ch.textContent = it.kind === 'dyo' ? 'The diamond in this piece has sold. Your setting is saved.' : 'This diamond has sold. Diamonds like it are still available.';
      $('[data-acts]', el).innerHTML = '<button type="button" class="tswp__btn" data-act="similar">See similar diamonds</button>';
      return;
    }
    if (r.price == null) return;
    $('[data-price]', el).textContent = money(r.price);
    var was = +it.price || 0, diff = r.price - was;
    if (was && Math.abs(diff) >= 100) {
      ch.hidden = false;
      ch.classList.toggle('is-down', diff < 0);
      ch.textContent = diff < 0 ? 'Price down ' + money(-diff) + ' since you saved it' : money(was) + ' when you saved it';
    }
  }
  function render() {
    var n = items.length;
    var signIn = root.getAttribute('data-login') || '/account/login';
    var head = '<header class="tswp__head"><div>' +
        '<p class="tswp__eyebrow">' + (SHARE ? 'Shared with you' : 'Saved for later') + '</p>' +
        '<h1 class="tswp__title">' + (SHARE ? 'A TrueSanity Wishlist' : 'Your Wishlist') + '</h1>' +
        (n ? '<p class="tswp__count">' + n + (n === 1 ? ' piece' : ' pieces') + '</p>' : '') +
      '</div>' +
      (n && !SHARE ? '<div class="tswp__tools"><button type="button" class="tswp__btn tswp__btn--line" data-act="share">Share your wishlist</button></div>' : '') +
      (SHARE ? '<div class="tswp__tools"><a class="tswp__btn tswp__btn--line" href="' + esc(location.pathname) + '">See your own wishlist</a></div>' : '') +
      '</header>';
    var st = T.state(), note = '';
    if (!SHARE && n && !T.cust) {
      note = '<div class="tswp__note"><span>Your wishlist is saved on this device. <a href="' + esc(signIn) + '">Sign in</a> to keep it on every device.</span>' +
        (st.email ? '' : '<form data-email novalidate><label class="tswp-vh" for="tswp-email">Email</label><input id="tswp-email" type="email" name="email" placeholder="Or leave your email" autocomplete="email" required><button class="tswp__btn" type="submit">Keep me posted</button></form>') +
      '</div>';
    }
    var body;
    if (!n) {
      body = '<div class="tswp__empty"><p>' + (SHARE ? 'This wishlist is empty right now.' : 'Tap the heart on any piece, setting or diamond to save it here.') + '</p>' +
        '<div class="tswp__tools"><a class="tswp__btn" href="/collections/engagement-ring-settings-shape">Engagement rings</a><a class="tswp__btn tswp__btn--line" href="/collections/all-jewelry">All jewelry</a></div></div>';
    } else body = '<div class="tswp__grid">' + items.map(card).join('') + '</div>';
    root.innerHTML = head + note + body;
    items.forEach(function (it) {
      check(it).then(function (r) { paintLive(root.querySelector('[data-key="' + CSS.escape(it.key) + '"]'), it, r); }, function () {});
    });
  }

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-act]'); if (!a) return;
    var el = a.closest('[data-key]'), it = el && items.filter(function (x) { return x.key === el.getAttribute('data-key'); })[0];
    var act = a.getAttribute('data-act');
    if (act === 'share') {
      e.preventDefault(); a.disabled = true;
      T.share().then(function (id) {
        a.disabled = false;
        if (!id) { T.toast('Sharing is not available right now. Please try again.'); return; }
        var url = location.origin + location.pathname + '?share=' + id;
        if (navigator.share) navigator.share({ title: 'My TrueSanity wishlist', text: 'A few pieces I love from TrueSanity.', url: url }).catch(function () {});
        else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { T.toast('Link copied. Send it to someone you love.'); }, function () { prompt('Copy this link', url); });
        else prompt('Copy this link', url);
      });
      return;
    }
    if (!it) return;
    e.preventDefault();
    if (act === 'remove') { T.remove(it.key); items = items.filter(function (x) { return x.key !== it.key; }); render(); return; }
    if (act === 'complete') return complete(it);
    if (act === 'similar') return similar(it);
  });
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-email]'); if (!f) return;
    e.preventDefault();
    var v = f.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { f.email.focus(); T.toast('Please enter a valid email.'); return; }
    T.email(v).then(function () { f.outerHTML = '<span>Thank you. We will keep you posted.</span>'; }, function () { f.outerHTML = '<span>Thank you. We will keep you posted.</span>'; });
  });

  function start() {
    if (!window.TSW) return setTimeout(start, 40);
    T = window.TSW; esc = T.esc; money = T.money;
    root.innerHTML = '<p class="tswp__loading">Loading your wishlist…</p>';
    if (SHARE) {
      fetch(T.api + '?share=' + encodeURIComponent(SHARE)).then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (j) { items = j.items || []; render(); }, function () { items = []; render(); });
      return;
    }
    T.ready.then(function () { items = T.items(); render(); });
    // another tab saved or removed something
    T.on(function (list) { if (list.length !== items.length) { items = T.items(); render(); } });
  }
  start();
})();
